/**
 * Fold state/city spelling, casing and punctuation variants onto a single canonical key.
 *
 *   "PUNJAB" / "Punjab" / " punjab " -> "PUNJAB"
 *   "Jammu & Kashmir" / "Jammu and Kashmir" -> "JAMMUANDKASHMIR"
 *
 * Used to dedupe dropdowns and to match dirty store strings against the 1Office master
 * WITHOUT mutating the stored data. Deliberately NOT fuzzy: genuinely different spellings
 * ("Andman And Nikobar") still fall out, because silently merging them would be unsafe.
 *
 * Lives here (rather than inside a page) so every consumer folds identically — a second,
 * subtly different copy is how state facets drift apart.
 */
export const normalizeLocationKey = (name: string | null | undefined): string =>
  (name || '').trim().toUpperCase().replace(/&/g, 'AND').replace(/[^A-Z0-9]/g, '');
